<template>
  <ApiPlaygroundView pageType="new_request" />

</template>
<script>
import { UseAppStore } from '@/stores/AppStore';
import ApiPlaygroundView from "@/views/admin/api-playground/View";

import ClientDataService from "@/services/ClientDataService";

export default {
  setup() {
    const appStore = UseAppStore();
    appStore.resetBreadcrumbs();
    appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    appStore.putBreadcrumbs("client", "Client Management", "/admin/client")
    return {
      appStore
    }
  },
  data() {
    return {
      alertType: '',
      alertMessage: '',
      client: {
        id: null,
        clientName: "",
        authToken: ""
      }
    }
  },
  components: {
    ApiPlaygroundView
  },
  methods: {
    onSubmit(client) {
      var data = {
        client_name: client.clientName,
        auth_token: client.authToken

      };

      console.log(JSON.stringify(data))
      ClientDataService.create(data)
        .then(() => {
          // client.id = response.data.id;
          // console.log(response.data.code_message);            
          // console.log(response.data);            
          this.alertType = 'Success'
          this.alertMessage = 'Client successfuly created'
          this.$router.replace('/admin/clients')
        })
        .catch(e => {
          this.alertType = 'Failed'
          this.alertMessage = e.response.data.code_message
          console.log(e);
        });
    }
  }
};
</script>
